"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IESService = exports.SpajService = void 0;
class SpajService {
    static data;
    static resultsList;
    static taux;
    static async getData(url, revenu) {
        var url = url + '?revenu=' + revenu;
        let response = await this.getJSON(url);
        this.data = response;
        return this.parseJobs(this.data);
    }
    static getJSON(url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    resolve(xhr.responseText);
                }
            };
            xhr.send();
        });
    }
    static parseJobs(response) {
        const results = JSON.parse(response);
        var that = this;
        that.taux = new Map();
        results.forEach(function (e) {
            that.taux.set(e.taux_prestation, e.prestation);
        });
        results.sort((n1, n2) => {
            if (parseInt(n1.taux_prestation) < parseInt(n2.taux_prestation)) {
                return 1;
            }
            if (parseInt(n1.taux_prestation) > parseInt(n2.taux_prestation)) {
                return -1;
            }
            return 0;
        });
        let merged = mergeByTauxPrestation(results);
        this.resultsList = merged;
    }
}
exports.SpajService = SpajService;
class IESService {
    static data;
    static resultsList;
    static taux;
    static async getData(url, status, nb, revenu) {
        var url = url + '?revenu=' + revenu + '&status=' + status + '&nb=' + nb;
        let response = await this.getJSON(url);
        this.data = response;
        return this.parseJobs(this.data);
    }
    static getJSON(url) {
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && xhr.status == 200) {
                    resolve(xhr.responseText);
                }
            };
            xhr.send();
        });
    }
    static parseJobs(response) {
        const results = JSON.parse(response);
        this.resultsList = results;
    }
}
exports.IESService = IESService;
// Fonction pour normaliser la donnée en tableau
function normalizeToArray(data) {
    return Array.isArray(data) ? data : [data];
}
function decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    var email_regex = /(\n|\ |\,)([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
    var tel_regex = /(((0041|0)|\+41)(\s?\(0\))?(\s)?[1-9]{2}(\s)?[0-9]{3}(\s)?[0-9]{2}(\s)?[0-9]{2})/gi;
    txt.innerHTML = txt.innerHTML.replace(email_regex, '$1<a href="mailto:$2">$2</a>');
    // no tel links
    //txt.innerHTML = txt.innerHTML.replace(tel_regex, '<a href="tel:$1">$1</a>');
    return txt.value;
}
function makeTime(d) {
    let parts = d.split('.');
    return new Date(parts[2], parts[1] - 1, parts[0]).getTime();
}
function mergeByTauxPrestation(data) {
    const map = new Map();
    for (const item of data) {
        if (!map.has(item.taux_prestation)) {
            map.set(item.taux_prestation, {
                taux_prestation: item.taux_prestation,
                revenu: item.revenu,
                taux_parent: item.taux_parent,
                taux_communal: item.taux_communal,
                prestations: [],
            });
        }
        const merged = map.get(item.taux_prestation);
        //if(! merged.prestations.find(i => i.type_structure==item.type_structure)) {
        // demande du SPAJ
        if (!(item.taux_prestation == '35' && item.type_structure == 'Préscolaire')) {
            merged.prestations.push({
                type_structure: item.type_structure,
                prix_reference: item.prix_reference,
                prestation: item.prestation,
                formule: item.formule,
                prix_parent: item.prix_parent,
                participation_communale: item.participation_communale,
            });
        }
        //}
    }
    return Array.from(map.values());
}
